import { render } from "./EnableUIFeatureModal.vue?vue&type=template&id=518be1b4"
import script from "./EnableUIFeatureModal.vue?vue&type=script&lang=js"
export * from "./EnableUIFeatureModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/EnableUIFeatureModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "518be1b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('518be1b4', __exports__)) {
    api.reload('518be1b4', __exports__)
  }
  
  module.hot.accept("./EnableUIFeatureModal.vue?vue&type=template&id=518be1b4", () => {
    api.rerender('518be1b4', render)
  })

}


export default __exports__